export default [
  {
    title: '2021 客户手册 v3.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%C2%A0%E5%AE%A2%E6%88%B7%E6%89%8B%E5%86%8C%C2%A0v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 38,
    longLine: false,
    title: '2021 产品指南 启航计划 Classic Lite  v3.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92%20Classic%20Lite%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 38,
    longLine: true,
    title: '2021 产品指南 启航计划 Classic Lite 长线规划服务 v3.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92%20Classic%20Lite%20%E9%95%BF%E7%BA%BF%E8%A7%84%E5%88%92%E6%9C%8D%E5%8A%A1%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 39,
    longLine: false,
    title: '2021 产品指南 标准计划 Standard  v3.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E6%A0%87%E5%87%86%E8%AE%A1%E5%88%92%20Standard%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 39,
    longLine: true,
    title: '2021 产品指南 标准计划 Standard 长线规划服务 v3.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E6%A0%87%E5%87%86%E8%AE%A1%E5%88%92%20Standard%20%E9%95%BF%E7%BA%BF%E8%A7%84%E5%88%92%E6%9C%8D%E5%8A%A1%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 37,
    longLine: false,
    title: '2021 产品指南 至领计划 Classic  v3.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92%20Classic%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 37,
    longLine: true,
    title: '2021 产品指南 至领计划 Classic 长线规划服务 v3.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92%20Classic%20%E9%95%BF%E7%BA%BF%E8%A7%84%E5%88%92%E6%9C%8D%E5%8A%A1%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 40,
    longLine: false,
    title: '2020 产品指南 英联邦国家申请 长线规划服务 v2.0.pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%E7%94%B3%E8%AF%B7%20%E9%95%BF%E7%BA%BF%E8%A7%84%E5%88%92%E6%9C%8D%E5%8A%A1%20v2.0.pdf'
  },
  {
    packageId: 40,
    longLine: true,
    title: '2020 产品指南 英联邦国家申请 v2.0',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%E7%94%B3%E8%AF%B7%20%20v2.0.pdf'
  },
  {
    packageId: 36,
    longLine: false,
    title: '2020 产品指南 菁英计划 Premier  v2.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92%20Premier%20%20v2.0%20%28secured%29.pdf'
  },
  {
    packageId: 36,
    longLine: true,
    title: '2020 产品指南 菁英计划 Premier 长线规划服务  v2.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92%20Premier%20%E9%95%BF%E7%BA%BF%E8%A7%84%E5%88%92%E6%9C%8D%E5%8A%A1%20%20v2.0%20%28secured%29.pdf'
  },
  {
    packageId: 66,
    longLine: false,
    title: '2021 产品指南 飞跃计划 Development  v3.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%A3%9E%E8%B7%83%E8%AE%A1%E5%88%92%20Development%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 35,
    longLine: false,
    title: '2020 产品指南 黑金计划 Aegis  v2.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%20v2.0%20%28secured%29.pdf'
  },
  {
    packageId: 35,
    longLine: true,
    title: '2020 产品指南 黑金计划 Aegis 长线规划服务  v2.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%E9%95%BF%E7%BA%BF%E8%A7%84%E5%88%92%E6%9C%8D%E5%8A%A1%20%20v2.0%20%28secured%29.pdf'
  },
  {
    packageId: 69,
    longLine: true,
    title: '2020 产品指南 菁英计划-艺术类 Premier v1.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92-%E8%89%BA%E6%9C%AF%E7%B1%BB%20Premier%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 69,
    longLine: false,
    title: '2020 产品指南 菁英计划-艺术类 Premier v1.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92-%E8%89%BA%E6%9C%AF%E7%B1%BB%20Premier%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 96,
    longLine: true,
    title: '2020 产品指南 菁英计划-艺术类 Premier v1.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92-%E8%89%BA%E6%9C%AF%E7%B1%BB%20Premier%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 96,
    longLine: false,
    title: '2020 产品指南 菁英计划-艺术类 Premier v1.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92-%E8%89%BA%E6%9C%AF%E7%B1%BB%20Premier%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 70,
    longLine: true,
    title: '2020 产品指南 至领计划-艺术类 Classic v1.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92-%E8%89%BA%E6%9C%AF%E7%B1%BB%20Classic%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 70,
    longLine: false,
    title: '2020 产品指南 至领计划-艺术类 Classic v1.0 (secured).pdf',
    url:
      'https://res.zailairen.com/msp/docs/2.0/product/2020%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92-%E8%89%BA%E6%9C%AF%E7%B1%BB%20Classic%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 122,
    longLine: false,
    title: '2021 产品指南 启航计划-英联邦国家  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 122,
    longLine: true,
    title: '2021 产品指南 启航计划-英联邦国家  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 121,
    longLine: false,
    title: '2021 产品指南 菁英计划-英联邦国家  v1.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%20%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 121,
    longLine: true,
    title: '2021 产品指南 菁英计划-英联邦国家  v1.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%20%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 120,
    longLine: false,
    title: '2021 产品指南 至领计划-英联邦国家  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 120,
    longLine: true,
    title: '2021 产品指南 至领计划-英联邦国家  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 137,
    longLine: false,
    title: '2021 产品指南 菁英计划 Premier 学术导向  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92%20Premier%20%E5%AD%A6%E6%9C%AF%E5%AF%BC%E5%90%91%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 137,
    longLine: true,
    title: '2021 产品指南 菁英计划 Premier 学术导向  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92%20Premier%20%E5%AD%A6%E6%9C%AF%E5%AF%BC%E5%90%91%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 138,
    longLine: false,
    title: '2021 产品指南 菁英计划 Premier 职业导向  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92%20Premier%20%E8%81%8C%E4%B8%9A%E5%AF%BC%E5%90%91%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 138,
    longLine: true,
    title: '2021 产品指南 菁英计划 Premier 职业导向  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%8F%81%E8%8B%B1%E8%AE%A1%E5%88%92%20Premier%20%E8%81%8C%E4%B8%9A%E5%AF%BC%E5%90%91%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 139,
    longLine: false,
    title: '2021 产品指南 黑金计划 Aegis 学术导向  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%E5%AD%A6%E6%9C%AF%E5%AF%BC%E5%90%91%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 139,
    longLine: true,
    title: '2021 产品指南 黑金计划 Aegis 学术导向  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%E5%AD%A6%E6%9C%AF%E5%AF%BC%E5%90%91%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 140,
    longLine: false,
    title: '2021 产品指南 黑金计划 Aegis 职业导向  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%E8%81%8C%E4%B8%9A%E5%AF%BC%E5%90%91%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 140,
    longLine: true,
    title: '2021 产品指南 黑金计划 Aegis 职业导向  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%E8%81%8C%E4%B8%9A%E5%AF%BC%E5%90%91%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 149,
    longLine: true,
    title: '2021 产品指南 至领计划-英联邦国家（港新）  v1.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%EF%BC%88%E6%B8%AF%E6%96%B0%EF%BC%89%20%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 149,
    longLine: false,
    title: '2021 产品指南 至领计划-英联邦国家（港新）  v1.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E8%87%B3%E9%A2%86%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%EF%BC%88%E6%B8%AF%E6%96%B0%EF%BC%89%20%20v1.0%20%28secured%29.pdf'
  },
  {
    packageId: 150,
    longLine: true,
    title: '2021 产品指南 启航计划-英联邦国家（港新）  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%EF%BC%88%E6%B8%AF%E6%96%B0%EF%BC%89%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 150,
    longLine: false,
    title: '2021 产品指南 启航计划-英联邦国家（港新）  v3.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E5%90%AF%E8%88%AA%E8%AE%A1%E5%88%92-%E8%8B%B1%E8%81%94%E9%82%A6%E5%9B%BD%E5%AE%B6%EF%BC%88%E6%B8%AF%E6%96%B0%EF%BC%89%20%20v3.0%20%28secured%29.pdf'
  },
  {
    packageId: 158,
    longLine: true,
    title: '2021 产品指南 标准计划 Standard  v4.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/0930/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E6%A0%87%E5%87%86%E8%AE%A1%E5%88%92%20Standard%20%20v4.0%20%28secured%29.pdf'
  },
  {
    packageId: 158,
    longLine: false,
    title: '2021 产品指南 标准计划 Standard  v4.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/0930/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E6%A0%87%E5%87%86%E8%AE%A1%E5%88%92%20Standard%20%20v4.0%20%28secured%29.pdf'
  },
  {
    packageId: 159,
    longLine: true,
    title: '2021 产品指南 黑金计划 Aegis 职业导向  v4.0 (secured).pdf ',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/0930/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%E8%81%8C%E4%B8%9A%E5%AF%BC%E5%90%91%20%20v4.0%20%28secured%29.pdf'
  },
  {
    packageId: 159,
    longLine: false,
    title: '2021 产品指南 黑金计划 Aegis 职业导向  v4.0 (secured).pdf ',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/0930/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%E8%81%8C%E4%B8%9A%E5%AF%BC%E5%90%91%20%20v4.0%20%28secured%29.pdf'
  },
  {
    packageId: 160,
    longLine: true,
    title: '2021 产品指南 黑金计划 Aegis 学术导向  v4.0 (secured).pdf ',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/0930/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%E5%AD%A6%E6%9C%AF%E5%AF%BC%E5%90%91%20%20v4.0%20%28secured%29.pdf'
  },
  {
    packageId: 160,
    longLine: false,
    title: '2021 产品指南 黑金计划 Aegis 学术导向  v4.0 (secured).pdf ',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2021/0930/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E9%BB%91%E9%87%91%E8%AE%A1%E5%88%92%20Aegis%20%E5%AD%A6%E6%9C%AF%E5%AF%BC%E5%90%91%20%20v4.0%20%28secured%29.pdf'
  },
  {
    packageId: 167,
    longLine: true,
    title: '2021 产品指南 标准计划（文商版） Standard  v4.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2022/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E6%A0%87%E5%87%86%E8%AE%A1%E5%88%92%EF%BC%88%E6%96%87%E5%95%86%E7%89%88%EF%BC%89%20Standard%20%20v4.0%20%28secured%29.pdf'
  },
  {
    packageId: 167,
    longLine: false,
    title: '2021 产品指南 标准计划（文商版） Standard  v4.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2022/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E6%A0%87%E5%87%86%E8%AE%A1%E5%88%92%EF%BC%88%E6%96%87%E5%95%86%E7%89%88%EF%BC%89%20Standard%20%20v4.0%20%28secured%29.pdf'
  },
  {
    packageId: 166,
    longLine: true,
    title: '2021 产品指南 标准计划（理工版） Standard  v4.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2022/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E6%A0%87%E5%87%86%E8%AE%A1%E5%88%92%EF%BC%88%E7%90%86%E5%B7%A5%E7%89%88%EF%BC%89%20Standard%20%20v4.0%20%28secured%29.pdf'
  },
  {
    packageId: 166,
    longLine: false,
    title: '2021 产品指南 标准计划（理工版） Standard  v4.0 (secured).pdf',
    url:
            'https://res.zailairen.com/msp/docs/2.0/product/2022/2021%20%E4%BA%A7%E5%93%81%E6%8C%87%E5%8D%97%20%E6%A0%87%E5%87%86%E8%AE%A1%E5%88%92%EF%BC%88%E7%90%86%E5%B7%A5%E7%89%88%EF%BC%89%20Standard%20%20v4.0%20%28secured%29.pdf'
  }
]
